import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=33d818b8"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports